import { Card } from './Card';
import {
	CardActions,
	CardBox,
	CardChip,
	CardContent,
	CardDescription,
	CardHeader,
	CardIcon,
	CardSubHeading,
	CardTitle,
} from './Card.styled';
import { ReactElement } from 'react';
import { Orientation, OrientationOptions } from './Card.props';
import { IconName } from '../icon';

export type IconCardProps = {
	title: string;
	subtitle?: string;
	description?: string;
	selected?: boolean;
	disabled?: boolean;
	chip?: ReactElement;
	actions?: ReactElement;
	icon: IconName;
	orientation?: Orientation;
}

export function IconCard({
	selected,
	disabled,
	title,
	subtitle,
	description,
	chip,
	icon,
	actions,
	orientation = OrientationOptions.vertical
}: IconCardProps) {
	return <Card selected={selected} disabled={disabled}>
		<CardBox $orientation={orientation} $padding={20} $gap={20}>
			<CardIcon icon={icon} />
			<CardContent>
				<CardHeader>
					<CardTitle>{title}</CardTitle>
					{chip && <CardChip>{chip}</CardChip>}
				</CardHeader>
				{subtitle && <CardSubHeading>{subtitle}</CardSubHeading>}
				{description && <CardDescription>{description}</CardDescription>}
				{actions ? <CardActions>{actions}</CardActions> : null}
			</CardContent>
		</CardBox>
	</Card>;
}
